/**
 * Ключи динамических фича флагов.
 */
export enum EFeatureFlags {
  FetchCredentials = 'sdr_admin_fetch_credentials',
  AdmissionExamReserve = 'admission_exam_reserve',
  EnrolledSectionParticipants = 'enrolled_section_participants',
}
